import { WaterOffOutlineIcon } from './WaterOffOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 8B8E5074-5348-4856-BBF0-461BA5022BF3
 * name water-off-outline
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-off-outline.svg
 * tags
 */
export const InkOffOutlineIcon = WaterOffOutlineIcon;
export default InkOffOutlineIcon